<template>
    <div class="box">
        <template>
            <Popup v-model="popup_show"
                position="top"
                overlay-class="popup_box"
                :close-on-click-overlay="false"
                :lock-scroll="true"
                :lazy-render="false">
                <img class="WXTExtension_popup" :src="popup_img">
            </Popup>
            
            <div class="page-header-box" v-if = "GetSuccessfulTrade.banner_type">
                <!-- 新用户 banner1至banner4 条件为：banner_type == 1 且 每天发送前4条-->
                <div class="page-header-type1" v-if = "GetSuccessfulTrade.banner_type == 1 && GetSuccessfulTrade.send_num < 5">
                    <div class="header-type-title">
                        <img class="header-type-title-img" :style="header_arr1[GetSuccessfulTrade.send_num].style" :src="$OSSBaseUrl+header_arr1[GetSuccessfulTrade.send_num].url" alt="">
                        {{header_arr1[GetSuccessfulTrade.send_num].title_desc}}
                    </div>
                    <div class="header-type1-content">
                        <div v-html="header_arr1[GetSuccessfulTrade.send_num].content_html">
                           
                        </div>
                        <div class="header-content-btn" @click="popupShow({btn_name:'upgrade_now'})">立即提升</div>
                    </div>
                </div>
                <!-- banner5至banner10 -->
                <div class="page-header-type2" v-if = "GetSuccessfulTrade.banner_type && GetSuccessfulTrade.banner_type != 1">
                    <div class="header-type-title">
                        <!-- 快到期用户header-title -->
                        <template v-if = "GetSuccessfulTrade.banner_type == 2">
                            <img class="header-type-title-img" style="width:3.86vw" :src="$OSSBaseUrl+'header_title_icon_05.png'">
                            <span>您的服务距到期仅剩{{GetSuccessfulTrade.expire_days}}天</span>
                        </template>  
                        <!-- 未授权用户header-title -->
                        <template v-if = "GetSuccessfulTrade.banner_type == 3">
                            <img class="header-type-title-img" style="width:3.86vw" :src="$OSSBaseUrl+'header_title_icon_06.png'">
                            <span>旺信通授权提醒</span>
                        </template> 
                    </div>
                    <div class="header-type2-content">
                        <!-- 快到期用户banner 条件为：banner_type == 2 且 小于每天推送的第6条 -->
                        <div class="header-type2-item" v-if = "GetSuccessfulTrade.banner_type == 2 && GetSuccessfulTrade.send_num < 6">
                            <img class="header-img" :style="header_arr2[GetSuccessfulTrade.send_num].style" :src="$OSSBaseUrl+header_arr2[GetSuccessfulTrade.send_num].url" alt="">
                            <div v-html="header_arr2[GetSuccessfulTrade.send_num].content_html">
                               
                            </div>
                        </div>
                        <!-- 未授权用户banner -->
                        <div class="header-type2-item" v-if = "GetSuccessfulTrade.banner_type == 3">
                            <img class="header-img" :style="header_arr2[0].style" :src="$OSSBaseUrl+header_arr2[0].url" alt="">
                            <div v-html="header_arr2[0].content_html">
                                
                            </div>
                        </div>
                        <div class="header-content-btn2" v-if = " GetSuccessfulTrade.banner_type != 3" @click="popupShow({btn_name:'special_renewal'})">特惠续费></div>
                    </div>
                </div>
            </div>
            <div v-for="(item,index) in Detail" :key="index" class="info_box">
                <div class="item_box">
                    <div class="item_title_box">
                        <div class="item_title_img_box">
                            <img class="item_title_img" :src="item.customer_grade ? level[item.customer_grade]['title_img'] : $OSSBaseUrl + 'head_portrait_B0.png'" >
                        </div>
                        <div class="item_title_text_box" :class="!item.customer_grade ? 'noB' : ''">
                            <div class="item_title_text_top">
                                <div class="item_title_name_box">
                                    <span class="item_title_name">{{item.buyer_nick ? item.buyer_nick : '--'}}</span>
                                    <span class="item_title_tips">（客户昵称）</span>
                                </div>
                                <div v-show="item.buyer_nick" ref="copy_customer" class="copy_button">复制</div>
                            </div>
                            <div class="item_title_text_bottom" v-if="item.customer_grade">
                                {{level[item.customer_grade]['text']}}<span class="item_title_text_number">{{level[item.customer_grade]['money']}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="problem_label_box">
                        <div class="problem_label_title">
                            <span>共交易 {{item.trading_num}} 次</span>
                            <span>{{item.last_trade}}</span>
                        </div>
                        <div class="problem_label_content">
                            <div class="problem_label_content_item blue_text">
                                <div class="item_price">
                                    <span class="item_price_unit" v-if="parseFloat(item.payment) != 0">￥</span>
                                    <span class="item_price_num">{{parseFloat(item.payment) != 0? item.payment : '--'}}</span>
                                </div>
                                <div class="item_desc">
                                    本次成交金额
                                </div>
                            </div>
                            <div class="problem_label_content_item black_text">
                                <div class="item_price">
                                    <span class="item_price_unit" v-if="parseFloat(item.payment_all) != 0">￥</span>
                                    <span class="item_price_num">{{parseFloat(item.payment_all) != 0 ? item.payment_all : '--'}}</span>
                                </div>
                                <div class="item_desc">
                                    成交总金额
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Clipboard from 'clipboard';
import { mapState } from 'vuex';
import { Toast , Dialog , NoticeBar, Popup } from 'vant';

export default {
    name: 'SuccessfulTrade',
    components:{
        Popup,NoticeBar,
    },
    data(){
        let popup_img
        if(this.$config.SystemOS=='IOS'){
            popup_img = this.$OSSBaseUrl +'renew_tips_ios.png';
        }else{
            popup_img = this.$OSSBaseUrl + 'renew_tips_android.png';
        }
        return{
            popup_img,
            popup_show: false,
            loading_data: false, //懒加载时防止重复触发
            level: { // 标识与后端对齐
                'B3':{'tag':'[高级]','text':'1688采购实力：近30天采购','money':'50000+','title_img': this.$OSSBaseUrl+'head_portrait_B3.png' },
                'B2':{'tag':'[中级]','text':'1688采购实力：近30天采购','money':'10000+','title_img': this.$OSSBaseUrl+'head_portrait_B2.png'},
                'B1':{'tag':'[初级]','text':'1688采购实力：近30天采购','money':'2000+','title_img': this.$OSSBaseUrl+'head_portrait_B1.png'},
            },
            // 新用户header数据
            header_arr1:[
                // 占位
                {},
                {
                    url: 'header_title_icon_01.png',
                    style: {
                        width: '3.74vw'
                    },
                    title_desc: '4800条短信提醒已到账',
                    content_html: `
                        <p class="header-content-desc">您有<span class="Red">63%</span>新客询单体验较差，平台已判定为</p>
                        <p class="header-content-desc"><span class="Red">低响应店铺，</span>将减少新客询单转化!</p>
                    `
                },
                {
                    url: 'header_title_icon_02.png',
                    style: {
                        width: '4.26vw'
                    },
                    title_desc: '1200分钟通话提醒已到账',
                    content_html: `
                        <p class="header-content-desc">由于平台搜索权重较低,店铺曝光<span class="Red">持续下降</span></p>
                        <p class="header-content-desc">商品曝光<span class="Red">远远低于同行！</span></p>
                    `
                },
                {
                    url: 'header_title_icon_03.png',
                    style: {
                        width: '5.06vw'
                    },
                    title_desc: '不限量微信提醒已到账',
                    content_html: `
                        <p class="header-content-desc">持续使用旺信通,一个月旺旺响应率</p>
                        <p class="header-content-desc"><span class="Red">提升80%以上</span></p>
                    `
                },
                {
                    url: 'header_title_icon_04.png',
                    style: {
                        width: '3.6vw'
                    },
                    title_desc: '169元补贴已到账',
                    content_html: `
                        <p class="header-content-desc">检测到您产品未显示<span class="Red">响应快</span>标签</p>
                        <p class="header-content-desc">会降低买家<span class="Red">52.3%</span>选择机会</p>
                    `
                },

            ],
            // 老用户header数据
            header_arr2:[
                {
                    url: 'header_tips_icon_04.png',
                    style: {
                        width: '8.54vw'
                    },
                    content_html: `
                        <p class="header-content-desc">【由于系统更新需重新授权】请登录旺信通</p>
                        <p class="header-content-desc"><span class="Red">PC页面直接授权，</span>否则将无法同步客户数据</p>
                    `
                },
                {
                    url: 'header_tips_icon_01.png',
                    style: {
                        width: '10vw'
                    },
                    content_html: `
                        <p class="header-content-desc">持续使用2个月</p>
                        <p class="header-content-desc">平台权重<span class="Red">提升46%以上</span></p>
                    `
                },
                {
                    url: 'header_tips_icon_01.png',
                    style: {
                        width: '10vw'
                    },
                    content_html: `
                        <p class="header-content-desc">持续使用3个月</p>
                        <p class="header-content-desc">同行占比<span class="Red">提升48%以上</span></p>
                    `
                },
                {
                    url: 'header_tips_icon_01.png',
                    style: {
                        width: '10vw'
                    },
                    content_html: `
                        <p class="header-content-desc">持续使用4个月</p>
                        <p class="header-content-desc">产品排行<span class="Red">提升38%以上</span></p>
                    `
                },
                {
                    url: 'header_tips_icon_03.png',
                    style: {
                        width: '6.8vw'
                    },
                    content_html: `
                        <p class="header-content-desc">若服务到期</p>
                        <p class="header-content-desc">将清空客户管理信息</p>
                    `
                },
                {
                    url: 'header_tips_icon_02.png',
                    style: {
                        width: '8.94vw'
                    },
                    content_html: `
                        <p class="header-content-desc">服务到期将至少</p>
                        <p class="header-content-desc">下降旺旺响应率<span class="Red">35%</span></p>
                    `
                }
            ],
            page: 0, //懒加载当前页数
            parame:{
                page: 1,
                pagesize: 10,
                // 下边参数都是url携带，取值返回给后台即可
                // 当前店铺的消息编号，第几条消息
                send_num: null,
                // 大于0小于6为新客户消息
                first_num: null,
                // 临到期天数
                last_num: null,
                // 发送的消息id
                order_send_msg: null,
                // code
                code: null
            },
        }
    },
    computed:{
        ...mapState({
            GetSuccessfulTrade: (state)=>{
                return state.SuccessfulTrade.GetSuccessfulTrade
            },
            Detail: (state)=>{
                return state.SuccessfulTrade.Detail
            },
        })
    },
    watch:{
        Detail:{
            handler: function (val, oldVal) {
                this.$nextTick(()=>{
                    let copy_customer = this.$refs.copy_customer
                    if(copy_customer){
                        let clipboard_customer = []
                        copy_customer.map((m,index)=>{
                            clipboard_customer[index] = new Clipboard(m,{
                                text: ()=>{
                                    return this.Detail[index].buyer_nick;
                                }
                            })
                            clipboard_customer[index].on('success', function (e) {
                                Toast('客户旺旺已复制')
                            });
                            clipboard_customer[index].on('error', function (e) {
                                Toast('复制客户旺旺失败')
                            });
                        })
                    }
                })
            },
            deep: true
        },
    },
    created(){
        var send_num = new URLSearchParams(window.location.search).get('send_num') || ''
        var first_num =  new URLSearchParams(window.location.search).get('first_num') || ''
        var last_num =  new URLSearchParams(window.location.search).get('last_num') || ''
        var order_send_msg =  new URLSearchParams(window.location.search).get('order_send_msg') || ''
        var code =  new URLSearchParams(window.location.search).get('code') || ''
        this.parame['send_num'] = send_num
        this.parame['first_num'] = first_num
        this.parame['last_num'] = last_num
        this.parame['order_send_msg'] = order_send_msg
        this.parame['code'] = code
        this.$store.commit('SuccessfulTrade/INIT_Detail',{})
        this.$store.dispatch('SuccessfulTrade/GetSuccessfulTrade', this.parame).then(res=>{
            if(res.code == 1000){
                this.parame.page += 1
            }else{
                Toast(res.message)
            }
        })
       
      
    },
    mounted () {
        this.$nextTick(function () {
            window.addEventListener('scroll', this.onScroll)
        })
        this.pageCollect()
    },
    beforeDestroy(){
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        // 埋点
        pageCollect(parame){
            let data = {
                page_from:'main_page',
                page_name:'SuccessfulTrade',
                page_time:'0.00',
                receiver_id: '',
                page_param:parame || {},
            }
            console.log(data,'--------------------埋点')
            this.$store.dispatch('Public/inH5Record', data)
        },
        // 显示弹窗
        popupShow(parame){
            this.popup_show = true
            this.pageCollect(parame)
        },
        // 获取滚动条当前的位置
        getScrollTop () {
            var scrollTop = 0
            if (document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop
            } else if (document.body) {
                scrollTop = document.body.scrollTop
            }
            return scrollTop
        },
        // 获取当前可视范围的高度
        getClientHeight () {
            var clientHeight = 0
            if (document.body.clientHeight && document.documentElement.clientHeight) {
                clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
            } else {
                clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
            }
            return clientHeight
        },

        // 获取文档完整的高度
        getScrollHeight () {
            return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        },
        // 滚动事件触发下拉加载
        onScroll () {
            if( this.GetSuccessfulTrade.total_num >  this.Detail.length){
                console.log(1)
                if( this.getScrollHeight() > this.getClientHeight() ){ // 文档高度高于可视窗口高度
                    if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 500) {
                        if( !this.loading_data){
                            this.loading_data = true
                            this.$store.dispatch('SuccessfulTrade/GetSuccessfulTrade', this.parame).then(res=>{
                                if(res.code == 1000){
                                    this.parame.page += 1
                                }else{
                                    Toast(res.message)
                                }
                                this.loading_data = false
                            })
                        }
                    }
                }
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>